import styled from 'styled-components'
import { deviceMax } from '../../theme/breakpoints'
import pxToRem from '../../utils/pxToRem'

import {
  FacebookShareButton,
  LinkedinShareButton,
  TwitterShareButton,
} from 'react-share'

export const StyledOverlay = styled.div`
  z-index: 99;
  top: 0;
  bottom: 0;
  position: fixed;
  justify-content: center;
  align-items: center;
  display: flex;
  width: 100%;
  background-color: ${({ theme }) => theme.colors.opacity.black70};
`

export const StyledOverlayContainer = styled.div`
  position: relative;
  justify-content: center;
  align-items: center;
  display: flex;
  flex-direction: column;
  padding: ${pxToRem(20)};
  border-radius: ${pxToRem(5)};
  width: 100%;
  max-width: ${pxToRem(620)};
  background-color: ${({ theme }) => theme.colors.unique.white};

  @media ${deviceMax.mobileL} {
    width: 90%;
  }
`

export const StyledOverlayTitle = styled.div`
  flex-direction: column;
  justify-content: center;
  align-items: center;
  display: flex;
`

export const StyledOverlayH3 = styled.h3`
  font-size: ${({ theme }) => theme.fonts.sizes.titleH3};
  line-height: ${({ theme }) => theme.fonts.lineHeight.titleH3};
  font-weight: ${({ theme }) => theme.fonts.weight.bold};
`
export const StyledOverlaySubtitle = styled.p`
  margin: ${pxToRem(20)};
  font-size: ${({ theme }) => theme.fonts.sizes.base};
  color: ${({ theme }) => theme.colors.opacity.black70};

  @media ${deviceMax.mobileL} {
    margin: ${pxToRem(5)};
  }
`

export const StyledOverlayIcons = styled.div`
  justify-content: space-evenly;
  display: flex;
  margin: ${pxToRem(20)};
  width: 100%;

  @media ${deviceMax.mobileL} {
    margin: ${pxToRem(5)};
  }
`

export const StyledLinkContainer = styled.div`
  flex-direction: column;
  align-items: center;
  justify-content: center;
  display: flex;
`

export const StyledOverlayIconLink = styled.a`
  align-items: center;
  justify-content: center;
  display: flex;
  border-radius: 50%;
  width: ${pxToRem(75.5)};
  height: ${pxToRem(75.5)};
  padding: ${pxToRem(24)};
  background-color: ${({ theme }) => theme.colors.secondary.whitesmoke};
`
export const StyledIconSubtitle = styled.p`
  padding: ${pxToRem(10)};
  font-size: ${({ theme }) => theme.fonts.sizes.base};
  line-height: ${pxToRem(15)};
  font-weight: ${({ theme }) => theme.fonts.weight.semibold};
  color: ${({ theme }) => theme.colors.opacity.black70};
`

export const StyledOverlayLinkFooter = styled.div`
  justify-content: center;
  align-items: center;
  flex-direction: column;
  display: flex;
  width: 100%;
`

export const StyledOverlayText = styled.p`
  margin: 0 0 ${pxToRem(10)} 0;
`

export const StyledOverlayLinkBlock = styled.div`
  position: relative;
  align-items: center;
  justify-content: space-between;
  display: flex;
  border-radius: ${pxToRem(5)};
  width: 100%;
  background-color: ${({ theme }) => theme.colors.secondary.whitesmoke};
  cursor: pointer;
`

export const StyledOverlayLink = styled.a`
  padding: ${pxToRem(17)};
  word-wrap: normal;
  overflow: hidden;
  text-overflow: ellipsis;
  font-size: ${({ theme }) => theme.fonts.sizes.base};
`

export const StyledOverlayCopyIcon = styled.div`
  justify-content: center;
  display: flex;
  margin: auto ${pxToRem(17)};
`

export const StyledCloseBtn = styled.div`
  position: absolute;
  top: ${pxToRem(16)};
  right: ${pxToRem(16)};
  justify-content: center;
  align-items: center;
  display: flex;
  cursor: pointer;
`

export const StyledOverlayLinkMessage = styled.div`
  z-index: 100;
  position: absolute;
  left: 0;
  right: 0;
  margin: auto;
  width: fit-content;
  box-shadow: ${({ theme }) => theme.boxShadows.overlay};
  border-radius: ${pxToRem(5)};
  padding: ${pxToRem(10)};
  background: ${({ theme }) => theme.colors.unique.white};
  background-color: ${({ theme }) => theme.colors.custom.aliceBlue};
`

export const StyledTwitterShareButton = styled(TwitterShareButton)`
  justify-content: center;
  align-items: center;
  display: flex;
`
export const StyledFacebookShareButton = styled(FacebookShareButton)`
  justify-content: center;
  align-items: center;
  display: flex;
`
export const StyledLinkedinShareButton = styled(LinkedinShareButton)`
  justify-content: center;
  align-items: center;
  display: flex;
`
